<template>
  <div>
    <main>
      <section class="absolute w-full h-full">
        <div class="absolute top-0 w-full h-full bg-white"
          style="background: linear-gradient(135deg, #CCD7CC, #E896A3, #A9C0EB, #5D7EB2)"></div>
        <div class="container mx-auto px-4 h-full">
          <div class="flex content-center items-center justify-center h-full">
            <div class="w-full lg:w-8/12 px-4">
              <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white ">
                <div class="flex-auto p-10 ">
                  <h6 class="text-gray-600 text-2xl font-medium mb-4">
                    Sign up to Hope Kit
                  </h6>
                  <form @submit.prevent>
                    <div class="relative w-full mb-3">
                      <label class="block  text-sm font-thin mb-2" for="grid-password">
                        What's your full name? <span class="text-xs text-accent-primary">(required)</span>
                      </label>
                      <Input type="text" v-model="user.full_name" placeholder="John Arbuckle"
                        style="transition: all 0.15s ease 0s;" />
                    </div>
                    <div class="relative w-full mb-3">
                      <label class="block  text-sm font-thin mb-2" for="grid-password">
                        What would you like us to call you? <span class="text-xs text-accent-primary">(required)</span>
                      </label>
                      <Input type="text" v-model="user.nickname" placeholder="John"
                        style="transition: all 0.15s ease 0s;" />
                    </div>
                    <div class="relative w-full mb-3">
                      <label class="block  text-sm font-thin mb-2" for="grid-password">
                        Phone Number: <span class="text-xs text-accent-primary">(required)</span>
                        <span class="block text-xs">Used for login verification</span>
                      </label>
                      <Input type="text" v-model="user.phone" placeholder="555-555-5555"
                        style="transition: all 0.15s ease 0s;" />
                    </div>
                    <div class="relative w-full mb-3">
                      <label class="block  text-sm font-thin mb-2" for="grid-password">
                        Email:
                        <span class="text-xs text-accent-primary">(required)</span>
                        <span class="block text-xs">Used for important notifications</span>
                      </label>
                      <Input type="text" v-model="user.email" placeholder="jim@example.com"
                        style="transition: all 0.15s ease 0s;" />
                    </div>
                    <div class="relative w-full mb-3">
                      <label class="block text-sm font-thin mb-2" for="grid-password">
                        Birth Date: <span class="text-xs text-accent-primary">(required)</span>
                      </label>
                      <Input type="date" v-model="user.birthdate" placeholder="YYYY-MM-DD"
                        style="transition: all 0.15s ease 0s;" />
                    </div>
                    <div class="relative w-full mb-3">
                      <label class="block  text-sm font-thin mb-2" for="grid-password">
                        Emergency Contact Person: <span class="text-xs text-accent-primary">(required)</span>
                      </label>
                      <Input type="text" v-model="user.emergency_contact_name" placeholder="Jane Cameron"
                        style="transition: all 0.15s ease 0s;" />
                    </div>
                    <div class="relative w-full mb-3">
                      <label class="block  text-sm font-thin mb-2" for="grid-password">
                        Emergency Contact Number: <span class="text-xs text-accent-primary">(required)</span>
                      </label>
                      <Input type="text" v-model="user.emergency_contact_phone" placeholder="555-565-5665"
                        style="transition: all 0.15s ease 0s;" />
                    </div>
                    <div class="mt-6">
                      <ul class="list text-red-500">
                        <li v-for="err in errors" :key="err">{{ err }}</li>
                      </ul>
                    </div>
                    <div class="text-center mt-6">
                      <Button class="text-white w-full" type="button" style="transition: all 0.15s ease 0s;"
                        @click="signup()">
                        Sign Up
                      </Button>
                      <small>Already have an account? <a href="/login" class="underline">Login</a></small>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>

  </div>
</template>

<script lang="ts" setup>
  import { ref } from 'vue'
  import type { User } from '@/stores/user'
  import { useUserStore } from '@/stores/user'
  import { useAuthStore } from '@/stores/auth'
  import type { ErrorResponse, ErrorDetail } from '@/models/error'
  import { Button } from '@/components/ui/button'
  import { Input } from '@/components/ui/input'

  const user = ref<User>({} as User)
  const errors = ref<string[]>([])
  const userStore = useUserStore()
  const authStore = useAuthStore()

  const signup = async () => {
    errors.value = []
    try {
      if (typeof user.value.id !== 'number') {
        const resp = await userStore.createUser(user.value)
        user.value = resp as User
      }
      userStore.setCurrentUser(user.value)
      await authStore.login(user.value.phone)
    } catch (err) {
      if (typeof err === 'object' && err!.constructor.name === 'Error') {
        const errResp = err as ErrorResponse
        const msg = errResp.body.detail
        if (msg.includes('violates unique constraint')) {
          errors.value = ['User with that phone number already exists, please login instead']
        } else {
          errors.value = [msg]
        }
        if (errResp.body.errors)
          errResp.body.errors.forEach((err: ErrorDetail) => {
            errors.value.push(err.message)
          })
      } else {
        console.error('Error creating user', err)
      }
    }
  }
</script>
